import { HorizontalStepper, StepItem } from '../jdshorizontalstepper';
import React, { forwardRef } from 'react';
import type {
  StepperProps,
  StepperRef
} from '../jdshorizontalstepper/interface';

import { Devices } from '../../service/Devices';
import { VerticalStepper } from './generated';

export const Stepper = forwardRef<StepperRef, StepperProps>(
  ({ orientation, ...rest }: StepperProps, ref) => {
    if (orientation === 'vertical') {
      return <VerticalStepper {...rest} ref={ref} orientation='vertical' />;
    }
    if (orientation === 'auto') {
      const isVertical = Devices.isMobile() && rest.children?.length > 6;
      if (isVertical)
        return <VerticalStepper ref={ref} {...rest} orientation='vertical' />;
    }
    return <HorizontalStepper {...rest} ref={ref} orientation='horizontal' />;
  }
);

export type { StepperProps, StepperRef };
export { StepItem };
